// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__2bA5X","container":"LayoutSideNavigation_container__28K5L","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__2XDFC"};